module.exports = __webpack_public_path__ + "img/tn-timeline-main-3.9758204f.jpg";